import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter } from "react-router-dom";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import { Container, Spinner } from "reactstrap";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Breadcrumbs from "components/Common/Breadcrumb";
import { gethomedata } from "store/home/actions";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "assets/scss/table.scss";

const styles = {
  card: {
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
    margin: "0 0 2rem 0",
    overflow: "hidden",
  },
  stepRow: {
    display: "flex",
    gap: "6px",
    padding: "14px 20px 0 20px",
    flexWrap: "wrap",
  },
  stepDone: {
    fontSize: "12px",
    padding: "3px 12px",
    borderRadius: "20px",
    background: "#eaf3de",
    color: "#27500a",
    border: "0.5px solid #c0dd97",
    fontWeight: "500",
  },
  stepActive: {
    fontSize: "12px",
    padding: "3px 12px",
    borderRadius: "20px",
    background: "#e6f1fb",
    color: "#1a1aaa",
    border: "0.5px solid #b5d4f4",
    fontWeight: "500",
  },
  stepIdle: {
    fontSize: "12px",
    padding: "3px 12px",
    borderRadius: "20px",
    background: "#f1f1f1",
    color: "#999",
    border: "0.5px solid #e0e0e0",
  },
  filterRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr 1fr",
    gap: "12px",
    padding: "14px 20px",
    alignItems: "end",
    borderBottom: "1px solid #eaeaea",
  },
  filterGroup: {
    position: "relative",
    width: "100%",
  },
  filterLabel: {
    display: "block",
    fontSize: "11px",
    fontWeight: "600",
    color: "#667085",
    marginBottom: "4px",
    textTransform: "uppercase",
    letterSpacing: "0.4px",
  },
  filterSelect: {
    width: "100%",
    height: "34px",
    padding: "0 28px 0 10px",
    border: "1px solid #d0d5dd",
    borderRadius: "4px",
    fontSize: "13px",
    color: "#344054",
    background: "#fff",
    appearance: "none",
    cursor: "pointer",
    fontFamily: "inherit",
  },
  filterSelectDisabled: {
    width: "100%",
    height: "34px",
    padding: "0 28px 0 10px",
    border: "1px solid #e8e8e8",
    borderRadius: "4px",
    fontSize: "13px",
    color: "#bbb",
    background: "#fafafa",
    appearance: "none",
    cursor: "not-allowed",
    fontFamily: "inherit",
  },
  chevron: {
    position: "absolute",
    right: "9px",
    top: "67%",
    transform: "translateY(-50%)",
    pointerEvents: "none",
    color: "#667085",
    fontSize: "11px",
  },
  emptyState: {
    textAlign: "center",
    padding: "3.5rem 1rem",
    color: "#bbb",
    fontSize: "14px",
  },
  tableTitle: {
    fontSize: "15px",
    fontWeight: "700",
    letterSpacing: "0.3px",
    padding: "14px 20px 4px 20px",
  },
  tableNote: {
    fontSize: "12.5px",
    color: "#555",
    padding: "0 20px 10px 20px",
    lineHeight: "1.5",
    maxWidth: "860px",
  },
  tableDivider: {
    borderTop: "2px solid #eaeaea",
    margin: "8px 0 0 0",
  },
};

class ParticipantListN extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copSchemes: [],
      coaSchemes: [],
      isLoading: true,
      selectedScheme: "",
      selectedCycle: "",
      selectedCertType: "",
      schemeOptions: [],
      cycleMap: {},
      participant_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : null,
      lab_participant_id: null,
    };

    this.commonHeader = {
      textAlign: "center",
      backgroundColor: "#a6d4ff",
      fontSize: "14px",
      fontWeight: "600",
      verticalAlign: "top",
      padding: "10px 8px 8px 8px",
    };

    this.commonHeaderCoa = {
      textAlign: "center",
      backgroundColor: "#1b7103",
      fontSize: "14px",
      fontWeight: "600",
      verticalAlign: "top",
      padding: "10px 8px 8px 8px",
      color: "#fff",
    };

    this.copColumns = this.buildColumns("cop");
    this.coaColumns = this.buildColumns("coa");
  }

  buildColumns(type = "cop") {
    const isCoa = type === "coa";
    const headerBase = isCoa ? this.commonHeaderCoa : this.commonHeader;

    return [
      {
        dataField: "scheme_name",
        text: "Scheme Name",
        sort: true,
        headerStyle: {
          ...headerBase,
          textAlign: "left",
          paddingLeft: "12px",
        },
        classes: "text-start align-middle",
        filter: textFilter({ placeholder: "Search..." }),
        formatter: cell =>
          isCoa ? (
            <span style={{ color: "#1b7103", fontWeight: "500" }}>{cell}</span>
          ) : (
            cell
          ),
        headerFormatter: (column, colIndex, components) => (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              paddingLeft: "4px",
            }}
          >
            <span
              style={{
                fontWeight: "600",
                fontSize: "13px",
                marginBottom: "4px",
              }}
            >
              {column.text}
              {components.sortElement}
            </span>
            {components.filterElement}
          </div>
        ),
      },
      {
        dataField: "cycle_id",
        text: "Cycle",
        sort: true,
        headerStyle: { ...headerBase, width: "160px" },
        classes: "text-center align-middle",
        filter: textFilter({ placeholder: "Search..." }),
        formatter: cell =>
          isCoa ? (
            <span style={{ color: "#1b7103", fontWeight: "500" }}>{cell}</span>
          ) : (
            cell
          ),
        headerFormatter: (column, colIndex, components) => (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <span
              style={{
                fontWeight: "600",
                fontSize: "13px",
                marginBottom: "4px",
              }}
            >
              {column.text}
              {components.sortElement}
            </span>
            {components.filterElement}
          </div>
        ),
      },
      {
        dataField: "scheme_id",
        text: "Action",
        headerStyle: { ...headerBase, width: "100px" },
        classes: "text-center align-middle",
        headerFormatter: column => (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <span style={{ fontWeight: "600", fontSize: "13px" }}>
              {column.text}
            </span>
          </div>
        ),
        formatter: cell => (
          <span
            role="button"
            className={`fw-semibold text-decoration-underline ${
              type === "cop" ? "text-primary" : "text-success"
            }`}
            onClick={() =>
              type === "cop"
                ? this.handleViewCertificate(cell)
                : this.handleViewCertificateAchievement(cell)
            }
          >
            View
          </span>
        ),
      },
    ];
  }

  componentDidMount() {
    const { participant_id } = this.state;
    if (participant_id) this.props.gethomedata(participant_id);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.home !== this.props.home && this.props.home) {
      const { purchased_schemes, payment_details, participant_id } =
        this.props.home;
      const payments = payment_details?.payments || [];

      const hasAnyFullDiscountPayment = payments.some(
        p => parseFloat(p.discount) === 100 && p.payment_status === "Paid"
      );

      const eligibleCycleIds = new Set();
      payments.forEach(p => {
        const isFullDiscount = parseFloat(p.discount) === 100;
        if (isFullDiscount) {
          (p.scheme || "").split(",").forEach(pair => {
            const [, cycleId] = pair.trim().split("-");
            if (cycleId) eligibleCycleIds.add(parseInt(cycleId));
          });
        }
      });

      const copSchemes = (purchased_schemes || [])
        .filter(
          s =>
            s.reportstatus === "Old" &&
            (s.payment_reconcile_status === "Verified" ||
              eligibleCycleIds.has(s.cycle_id) ||
              hasAnyFullDiscountPayment)
        )
        .map(s => ({
          scheme_id: s.scheme_id,
          scheme_name: s.scheme_name,
          cycle_id: s.cycle_no || "—",
          cycle_db_id: s.cycle_id,
        }));

      const coaSchemes = (purchased_schemes || [])
        .filter(
          s =>
            s.reportstatus === "Old" &&
            (s.payment_reconcile_status === "Verified" ||
              hasAnyFullDiscountPayment)
        )
        .map(s => ({
          scheme_id: s.scheme_id,
          scheme_name: s.scheme_name,
          cycle_id: s.cycle_no || "—",
          cycle_db_id: s.cycle_id,
        }));

      const schemeMap = {};
      (purchased_schemes || [])
        .filter(s => s.reportstatus === "Old")
        .forEach(s => {
          if (!schemeMap[s.scheme_id]) {
            schemeMap[s.scheme_id] = { scheme_name: s.scheme_name, cycles: [] };
          }
          schemeMap[s.scheme_id].cycles.push({
            cycle_id: s.cycle_id,
            cycle_no: s.cycle_no,
          });
        });

      const schemeOptions = Object.entries(schemeMap).map(([id, val]) => ({
        scheme_id: parseInt(id),
        scheme_name: val.scheme_name,
      }));

      this.setState({
        copSchemes,
        coaSchemes,
        schemeOptions,
        cycleMap: schemeMap,
        payments,
        lab_participant_id: participant_id,
        isLoading: false,
      });
    }
  }

  handleSchemeChange = e => {
    const scheme_id = e.target.value ? parseInt(e.target.value) : "";
    this.setState({
      selectedScheme: scheme_id,
      selectedCycle: "",
      selectedCertType: "",
    });
  };

  handleCycleChange = e => {
    this.setState({
      selectedCycle: e.target.value ? parseInt(e.target.value) : "",
      selectedCertType: "",
    });
  };

  handleCertTypeChange = e => {
    this.setState({ selectedCertType: e.target.value });
  };

  handleViewCertificate = scheme_id => {
    const organization_name =
      localStorage.getItem("organization_name") || "default-org";
    const { lab_participant_id, copSchemes } = this.state;
    const matched = copSchemes.find(s => s.scheme_id === scheme_id);
    if (!matched) return;
    const authUser = localStorage.getItem("authUser")
      ? JSON.parse(localStorage.getItem("authUser"))
      : null;
    const account_id = authUser?.user_id || "";
    this.props.history.push(
      `/${organization_name}/${lab_participant_id}/certificate?scheme_id=${scheme_id}&cycle_id=${matched.cycle_db_id}&account_id=${account_id}`
    );
  };

  handleViewCertificateAchievement = scheme_id => {
    const organization_name =
      localStorage.getItem("organization_name") || "default-org";
    const { lab_participant_id, coaSchemes } = this.state;
    const matched = coaSchemes.find(s => s.scheme_id === scheme_id);
    if (!matched) {
      console.error("No Old cycle found for scheme_id:", scheme_id);
      return;
    }
    const authUser = localStorage.getItem("authUser")
      ? JSON.parse(localStorage.getItem("authUser"))
      : null;
    const account_id = authUser?.user_id || "";
    this.props.history.push(
      `/${organization_name}/${lab_participant_id}/certificate_of_achievement?scheme_id=${scheme_id}&cycle_id=${matched.cycle_db_id}&account_id=${account_id}`
    );
  };

  pageOptions = total => ({
    sizePerPage: 20,
    totalSize: total,
    custom: true,
  });

  getStep() {
    const { selectedScheme, selectedCycle, selectedCertType } = this.state;
    if (selectedCertType) return 4;
    if (selectedCycle) return 3;
    if (selectedScheme) return 2;
    return 1;
  }

  renderSteps() {
    const step = this.getStep();
    const labels = [
      "Select Scheme",
      "Select Cycle",
      "Certificate Type",
      "Done",
    ];
    return (
      <div style={styles.stepRow}>
        {labels.map((label, i) => {
          const num = i + 1;
          const s =
            num < step
              ? styles.stepDone
              : num === step
              ? styles.stepActive
              : styles.stepIdle;
          return (
            <span key={num} style={s}>
              {num}. {label}
            </span>
          );
        })}
      </div>
    );
  }

  renderSingleTable(type, schemes) {
    const isCop = type === "cop";
    const columns = isCop ? this.copColumns : this.coaColumns;
    const title = isCop
      ? "Certificate of Participation (COP)"
      : "Certificate of Achievement (COA)";
    const note = isCop
      ? "Once participation is approved after payment verification, the Certificate of Participation (COP) will appear in the table for the respective scheme. The QR code on the certificate can be scanned to instantly verify its authenticity online."
      : "The Certificate of Achievement (COA) is awarded to participants who successfully meet all criteria. Certificates are available once the scheme cycle is complete and results are finalized. Scan the QR code to verify the certificate's authenticity instantly.";

    return (
      <>
        <div
          style={{
            ...styles.tableTitle,
            color: isCop ? "#0d6efd" : "#1b7103",
          }}
        >
          {title}
        </div>
        <div style={styles.tableNote}>{note}</div>

        <PaginationProvider
          pagination={paginationFactory(this.pageOptions(schemes.length))}
          keyField="scheme_id"
          columns={columns}
          data={schemes}
        >
          {({ paginationProps, paginationTableProps }) => (
            <ToolkitProvider
              keyField="scheme_id"
              data={schemes}
              columns={columns}
              search
            >
              {toolkitProps => (
                <>
                  <div className="table-responsive mx-3 mb-3">
                    <BootstrapTable
                      keyField="scheme_id"
                      data={schemes}
                      columns={columns}
                      bordered={false}
                      striped={false}
                      hover
                      classes="table align-middle table-condensed"
                      headerWrapperClasses={
                        isCop ? "table-header-sky-blue" : "table-header-olive"
                      }
                      filter={filterFactory()}
                      noDataIndication={
                        <div className="text-center text-muted py-3">
                          No schemes available
                        </div>
                      }
                      {...toolkitProps.baseProps}
                      {...paginationTableProps}
                    />
                  </div>
                  {schemes.length > 20 && (
                    <PaginationListStandalone {...paginationProps} />
                  )}
                </>
              )}
            </ToolkitProvider>
          )}
        </PaginationProvider>
      </>
    );
  }

  renderTable() {
    const {
      selectedScheme,
      selectedCycle,
      selectedCertType,
      copSchemes,
      coaSchemes,
    } = this.state;

    if (!selectedScheme || !selectedCycle || !selectedCertType) {
      return (
        <div style={styles.emptyState}>
          Select a scheme, cycle and certificate type to view certificates
        </div>
      );
    }

    const filteredCop = copSchemes.filter(s => s.cycle_db_id === selectedCycle);
    const filteredCoa = coaSchemes.filter(s => s.cycle_db_id === selectedCycle);

    if (selectedCertType === "both") {
      return (
        <>
          {this.renderSingleTable("cop", filteredCop)}
          <div style={styles.tableDivider} />
          {this.renderSingleTable("coa", filteredCoa)}
        </>
      );
    }

    const isCop = selectedCertType === "cop";
    const schemes = isCop ? filteredCop : filteredCoa;
    return this.renderSingleTable(selectedCertType, schemes);
  }

  render() {
    const {
      isLoading,
      selectedScheme,
      selectedCycle,
      selectedCertType,
      schemeOptions,
      cycleMap,
    } = this.state;

    const cycleOptions =
      selectedScheme && cycleMap[selectedScheme]
        ? cycleMap[selectedScheme].cycles
        : [];

    return (
      <div className="page-content">
        <MetaTags>
          <title>Certificates</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Labs" breadcrumbItem="Certificates List" />
          {isLoading ? (
            <div className="text-center py-5">
              <Spinner color="primary" />
            </div>
          ) : (
            <div style={styles.card}>
              {/* Step indicator */}
              {this.renderSteps()}

              {/* Filter dropdowns — 4-column grid */}
              <div style={styles.filterRow}>
                {/* Scheme */}
                <div style={styles.filterGroup}>
                  <label style={styles.filterLabel}>Scheme</label>
                  <select
                    style={styles.filterSelect}
                    value={selectedScheme}
                    onChange={this.handleSchemeChange}
                  >
                    <option value="">Select Scheme</option>
                    {schemeOptions.map(s => (
                      <option key={s.scheme_id} value={s.scheme_id}>
                        {s.scheme_name}
                      </option>
                    ))}
                  </select>
                  <span style={styles.chevron}>▾</span>
                </div>

                {/* Cycle */}
                <div style={styles.filterGroup}>
                  <label style={styles.filterLabel}>Cycle</label>
                  <select
                    style={
                      selectedScheme
                        ? styles.filterSelect
                        : styles.filterSelectDisabled
                    }
                    value={selectedCycle}
                    onChange={this.handleCycleChange}
                    disabled={!selectedScheme}
                  >
                    <option value="">Select Cycle</option>
                    {cycleOptions.map(c => (
                      <option key={c.cycle_id} value={c.cycle_id}>
                        Cycle {c.cycle_no}
                      </option>
                    ))}
                  </select>
                  <span style={styles.chevron}>▾</span>
                </div>

                {/* Certificate Type */}
                <div style={styles.filterGroup}>
                  <label style={styles.filterLabel}>Certificate Type</label>
                  <select
                    style={
                      selectedCycle
                        ? styles.filterSelect
                        : styles.filterSelectDisabled
                    }
                    value={selectedCertType}
                    onChange={this.handleCertTypeChange}
                    disabled={!selectedCycle}
                  >
                    <option value="">Select Type</option>
                    <option value="cop">
                      COP — Certificate of Participation
                    </option>
                    <option value="coa">
                      COA — Certificate of Achievement
                    </option>
                    <option value="both">Both — COP &amp; COA</option>
                  </select>
                  <span style={styles.chevron}>▾</span>
                </div>

                {/* Empty 4th col */}
                <div />
              </div>

              {/* Result table */}
              {this.renderTable()}
            </div>
          )}
        </Container>
      </div>
    );
  }
}

ParticipantListN.propTypes = {
  gethomedata: PropTypes.func.isRequired,
  home: PropTypes.shape({
    purchased_schemes: PropTypes.array,
    payment_details: PropTypes.shape({
      payments: PropTypes.array,
    }),
    open_rounds: PropTypes.array,
    report_available_rounds: PropTypes.array,
    participant_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default connect(state => ({ home: state.home.home }), { gethomedata })(
  withRouter(ParticipantListN)
);
